import { PressEvent } from "react-aria-components";

import { Gear } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import Box from "ds/components/Box";

type TableSettingsProps = {
  title: string;
  onPress?: (e: PressEvent) => void;
};

const TableSettings = ({ title, onPress }: TableSettingsProps) => {
  return (
    <Box gap="small" align="center" justify="between" fullHeight>
      <span className="sr-only">{title}</span>
      <ButtonIcon size="small" variant="ghost" onPress={onPress} icon={Gear}>
        Customize table layout
      </ButtonIcon>
    </Box>
  );
};

TableSettings.displayName = "DS.Table.Settings";

export default TableSettings;
